exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js?{\"modules\":true,\"importLoaders\":1,\"localIdentName\":\"[name]_[local]_[hash:base64:5]\"}!../../../node_modules/postcss-loader/lib/index.js??postcss!../../fonts.css"), undefined);

// module
exports.push([module.id, ".PaymentInfo_container_RkyUC {\n  margin: 5rem auto 0 auto;\n  width: 19.5rem;\n}\n\n.PaymentInfo_odContainer_k3ibM {\n  margin: 1.75rem auto 0 auto;\n  width: 15rem;\n}\n\n.PaymentInfo_container_RkyUC p {\n  margin: 0.25rem 0;\n  clear: both;\n}\n\n.PaymentInfo_odContainer_k3ibM p {\n  margin: 0.25rem 0;\n  clear: both;\n}\n\n.PaymentInfo_right_28WWs {\n  float: right;\n}\n\n.PaymentInfo_total_31na3 {\n  font-size: 1.4rem;\n}\n", ""]);

// exports
exports.locals = {
	"container": "PaymentInfo_container_RkyUC",
	"odContainer": "PaymentInfo_odContainer_k3ibM",
	"right": "PaymentInfo_right_28WWs",
	"total": "PaymentInfo_total_31na3 " + require("-!../../../node_modules/css-loader/index.js?{\"modules\":true,\"importLoaders\":1,\"localIdentName\":\"[name]_[local]_[hash:base64:5]\"}!../../../node_modules/postcss-loader/lib/index.js??postcss!../../fonts.css").locals["proximaNovaSemiBold"] + ""
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[name]_[local]_[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/containers/CartPage/PaymentInfo.css
// module id = 981
// module chunks = 0